import React, { useCallback, useState, useEffect } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import Dropdown from './Dropdown';
import logo from './Icons/logo.png';
import notificationBell from './Icons/notificationBell.png';
import searchIcon from './Icons/searchIcon.png';
import NotificationDropdown from './NotificationDropdown';
import { useNotification } from "./Notifications/NotificationProvider";
import Modal from 'react-modal';
import { customStyles } from './Modules/CustomStyle';
import { errorExplinationMark } from './Icons';

const Navbar = ({ akrCookie, loggedIn, akrAuth, logOutUser }) => {
  const { addNotification } = useNotification();
  const [isNotificationVisible, setIsNotificationVisible] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);
  const [gatheredNotifications, setGatheredNotifications] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (loggedIn && !gatheredNotifications) {
      gatherNotifications()
      setGatheredNotifications(true)
    }
    if (isNotificationVisible && loggedIn) gatherNotifications()
  }, [isNotificationVisible, gatheredNotifications, loggedIn]);

  const gatherNotifications = async () => {
    try {
      if (!loggedIn) return;
      const response = await fetch('https://api.kasimakram.com/notifications', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'akrAuth': JSON.stringify(akrAuth),
          'akrCookie': akrCookie
        },
        credentials: 'include'
      });
      const result = await response.json();
      if (response.ok) {
        setNotifications(result)
        let totalNotifications = 0;
        result.forEach(notification => {
          if (notification.type !== "frp" && notification.type !== "frd") {
            totalNotifications++;
          }
        });
        setNotificationCount(totalNotifications);
        return;
      } else {
        if (result.error === "invalidCookie") {
          addNotification({
            title: `Signing you out`,
            message: `Sign back in to join the fun!`,
            imageUrl: errorExplinationMark,
          });
          await handleLogout()
          return;
        } else {
          addNotification({
            title: `System Error`,
            message: result.frontFacingError || result.error,
            imageUrl: errorExplinationMark,
          });
        }
        console.log(result.frontFacingError);
      }
      return;
    } catch (error) {
      console.error('Error:', error);
      return;
    }
  };

  const handleLogout = useCallback(() => {
    const { profilePicture, fullName } = akrAuth;
    logOutUser()
    navigate('/');
    return addNotification({
      title: `Signed out`,
      message: `(${fullName}) Signed out successfully!`,
      imageUrl: profilePicture,
    });
  }, [akrAuth, logOutUser, navigate, addNotification]);

  const handleSearchClick = () => {
    navigate('/search');
  }

  const openUI = async (type) => {
    setFadeOut(false);
    if (type === "notification") setIsNotificationVisible(true)
    return;
  }

  const closeUI = async (type) => {
    setFadeOut(true);
    if (type === "notification") setTimeout(() => setIsNotificationVisible(false), 75);
    return;
  }

  const renderNotification = async () => {
    gatherNotifications()
    return;
  }

  return (
    <nav className="navbar">
      <Link to="/" className="navbarLogoLink">
        <img className="navbarLogo" src={logo} alt="Akr" />
      </Link>
      <div className="navbar-links">
        {loggedIn ? (
          <div className="centeredContainer">
            <img className="notificationBellCSS" alt="" src={searchIcon} onClick={handleSearchClick} />
            <div className="notificationBellContainer">
              <img className="notificationBellCSS" alt="" src={notificationBell} onClick={() => openUI("notification")} />
              {notificationCount > 0 && <div className="notificationCount">{notificationCount}</div>}
            </div>
            {isNotificationVisible && (
              <div className="notificationDropdownWrapper">
                <Modal isOpen={isNotificationVisible} style={customStyles} className={`react-modal ${fadeOut ? 'fadeOut' : ''}`} onRequestClose={() => closeUI("notification")} contentLabel="Notification Modal" >
                  <NotificationDropdown closeUI={closeUI} notifications={notifications} renderNotification={renderNotification} akrAuth={akrAuth} akrCookie={akrCookie} />
                </Modal>
              </div>
            )}
            <Dropdown loggedIn={loggedIn} akrAuth={akrAuth} onLogout={handleLogout} />
          </div>
        ) : (
          <NavLink to="/login" className="forceWhiteLink navbarLoginButton">Sign in</NavLink>
        )}
      </div>
    </nav>
  );
};

export default Navbar;